<template>
    <div>
        <div class="container-input">
            <b-icon icon="search" class="icono-buscar"></b-icon>
            <input type="text" v-model="searchQuery" placeholder="Buscar" name="text" class="input">
        </div>
    </div>
</template>
<script>
import { EventNames } from '@/plugins/enums/index.js'

export default {
    name: 'SearchUser',

    data() {
        return {
            searchQuery: ''
        }
    },

    methods: {
        filteredItems() {
            this.$eventBus.$emit(EventNames.FilterUsersAfterSearch, this.searchQuery);
        }
    },

    watch: {
        'searchQuery'() {
            this.filteredItems();
        }
    }

}
</script>
<style scoped>
.container-input {
    position: relative;
}

.input {
    width: 150px;
    padding: 10px 0px 10px 40px;
    border-radius: 9999px;
    border: solid 1px #0073AA;
    transition: all .2s ease-in-out;
    outline: none;
    opacity: 0.8;
}

.container-input svg {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translate(0, -50%);
}

.input:focus {
    opacity: 1;
    width: 250px;
}

.icono-buscar {
    color:  #5AA9E6;
}
</style>